import {
    DISPATCH_JOB_TEAM_VISIBILITY_ALL,
    DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_ONLY,
    DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_OR_UNSET,
} from "../constants/company";
import type { DispatchJobTeamVisibility } from "../constants/company";
import { Job } from "../types/job";

export interface DispatchJobVisibilityRequest {
    active: boolean;
    teamIds: number[];
    includeUnsetTeam: boolean;
}

export function getDispatchJobTeamVisibility(
    value: string | undefined,
): DispatchJobTeamVisibility {
    if (value === DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_OR_UNSET
        || value === DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_ONLY
    ) {
        return value;
    }
    return DISPATCH_JOB_TEAM_VISIBILITY_ALL;
}

export function getDispatchJobVisibilityRequest(
    visibility: string | undefined,
    teamIds: number[] | undefined,
): DispatchJobVisibilityRequest {
    const normalizedVisibility = getDispatchJobTeamVisibility(visibility);
    const normalizedTeamIds = Array.from(new Set((teamIds ?? []).filter((teamId) => teamId > 0)));

    if (normalizedVisibility === DISPATCH_JOB_TEAM_VISIBILITY_ALL || normalizedTeamIds.length === 0) {
        return {
            active: false,
            teamIds: [],
            includeUnsetTeam: false,
        };
    }

    return {
        active: true,
        teamIds: normalizedTeamIds,
        includeUnsetTeam: normalizedVisibility === DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_OR_UNSET,
    };
}

export function matchesDispatchJobVisibility(job: Job, visibility: DispatchJobVisibilityRequest): boolean {
    if (!visibility.active) {
        return true;
    }
    const teamId = job.teamId || 0;
    if (teamId === 0) {
        return visibility.includeUnsetTeam;
    }
    return visibility.teamIds.includes(teamId);
}
